import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import AdvertiserForm from './AdvertiserForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditAdvertiserModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( { advertiser } ) => {
        this.setState( { fetching: true } );
        this.props.updateAdvertiser( advertiser.advertiserid, advertiser )
        .then( ( newAdvertiser ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newAdvertiser );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteAdvertiser = () => {
        this.setState( { fetching: true } );
        this.props.deleteAdvertiser( this.props.advertiser.advertiserid )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit();
        } );
    }
    render() {
        const { advertiser, affiliateType } = this.props;

        var initialValues = {
            affiliateType: affiliateType,
            ...advertiser,
            advertiserDomainsText: AdvertiserForm.advertiserDomainsToText(advertiser.advertisers_domains),
        };

        return (
            <DLModal title='Edit Advertiser'
            closeHandler={ this.props.closeModal }>
                <div>
                    <AdvertiserForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS ADVERTISER?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteAdvertiser }>
                            DELETE ADVERTISER
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS ADVERTISER
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateAdvertiser: ( id, data ) => {
            return dAPI.patch( `/affiliates/dbadvertisers/${ id }`, data );

        },
        deleteAdvertiser: ( id ) => {
            return dAPI.delete( `/affiliates/dbadvertisers/${ id }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditAdvertiserModal );
